const notEmptyFun = (obj: any, arr: any) => {
  let flag = true;
  arr.every((value: string) => {
    if (obj[value] === '') {
      flag = false;
      return false;
    } else {
      return true;
    }
  });
  return flag;
};
export default notEmptyFun;

// const obj = {
//   a: '2',
//   b: '2',
//   c: '2qq',
// };
// const arr = [ 'b','a','c'];

// console.log(notEmptyFun(obj, arr));


